import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import { useTranslation } from "next-i18next";
import PAImage from "component/design-system/images/PAImage";
import { getRelativeImagePath } from "util/helper/getRelativeImagePath";
import styles from "./shipping-perks.module.scss";

interface IProps {
  data: {
    title: string;
    subTitle: string;
    src: string;
  }[]
}

function ShippingPerks(props: IProps) {
  const { data } = props;
  const { t } = useTranslation("static-pages");
  return (
    <div className={`d-flex justify-content-between ${styles.container}`}>
      {
        data.map((each) => (
          <div className={`d-flex flex-column m-b-20 ${styles.perks_each}`} key={each.title}>

            <PAImage
              src={getRelativeImagePath(each.src)}
              mobileHeight={60}
              tabletHeight={80}
              desktopHeight={100}
              width={100}
              className={styles.icon}
              alt="icon"
            />

            <div className={styles.text_container}>
              <PAText component="h2" color="black" bold fontSize={FONT_SIZE[3]} className="text-center">{t(each.title)}</PAText>
              <PAText color="light-grey" fontSize={FONT_SIZE[1]} className="text-center">{t(each.subTitle)}</PAText>
            </div>
          </div>
        ))
      }
    </div>
  );
}

export default ShippingPerks;
